import { BlockModel } from '@client/components/Block/model'
import { defaultSettings } from './constants'

export default class SpacingModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    this.editor = editor

    this.settings.set({ ...defaultSettings, ...data.settings })
  }
}

export const NULL = new SpacingModel()
